<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <br><br><br>
            <div class="row">
              <div class="text-center col-md-12">
                <img src="static/img/background/declaranet_logo.png" alt="declaraNet" class="d-logo mb-3">
              </div>
            </div>
            <br>
            <div class="row ocultar" id="formResetPass">
              <div class="col-md-6 ">
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-success">
                      <i class="ti ti-user"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Actualiza tu contraseña</h5>
                    <p v-if="nombre != ''" style="text-transform: capitalize;">Hola, {{nombre | lowercase}}!</p>
                    Como medida de seguridad, el primer paso será cambiar tu contraseña
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <form method="#" action="#">
                  <div class=" card-plain">
                    <div class="content">
                      <div class="form-group">
                        <label for="password">Contraseña</label>
                        <input v-validate="'required|regex:^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$|min:8'" required name="password" type="password" class="form-control" placeholder="Contraseña" ref="password" v-model="password">
                      </div>
                      <div class="form-group">
                        <label for="password_cofirmation">Confirma la Contraseña</label>
                        <input v-validate="'required|confirmed:password'" required name="password_confirmation" type="password" class="form-control" placeholder="Confirma la contraseña" data-vv-as="password">
                      </div>
                      <div class="alert alert-danger" v-show="errors.any()">
                        <div v-if="errors.has('password')">
                          La contraseña debe ser alfanumérica y de 8 caracteres mínimo
                        </div>
                        <div v-if="errors.has('password_confirmation')">
                          <span class="texto">Las contraseñas no coinciden</span>
                        </div>
                      </div>
                      <div class="footer text-center">
                        <button type="button" @click.prevent="actualiza()" class="btn btn-fill btn-info btn-wd" :disabled="errors.any()">Actualizar</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapFields
  } from 'vee-validate'

  export default {
    props: {
      user: {
        type: String,
        default: () => ""
      },
      upass: {
        type: String,
        default: () => ""
      },
    },
    data() {
      return {
        ip_id: null,
        password: '',
        able: false,
        passwordConfirm: '',
        declarante: {},
        nombre: '',
      }
    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      actualiza() {
        if (this.password != '') {
          this.$http.post('updatePass/' + this.password).then(
            response => {
              this.setSession(response.data);
              console.log(this.getKey('status_dec'))
              if (this.getKey('status_dec') == 1) {
                this.$router.push('/forms/tablero')
              } else {
                this.$router.push('/forms/enviada');
                localStorage.setItem('std', 0);
              }

              this.$router.go();
            }, error => {
              this.StepError(error);
              //console.log(error);
            })
        } else {
          this.Err("El campo no puede estar vacío")
        }

      }
    },
    beforeDestroy() {
      this.closeMenu()
    },
    created() {
      // console.log(this.user, this.upass);
      // this.ip_id = this.getId();

      // Necesita TOKEN
      this.$http.get("recupera_check_user/" + this.user + "/" + this.upass).then(
        response => {
          if (response.data.token) {
            var form = document.getElementById("formResetPass");
            form.classList.remove("ocultar");

            this.setSession(response.data);
            this.nombre = this.getKey('nombre');
          } else {
            setTimeout(() => {
              this.$router.push('/login');
              this.$router.go();
            }, 5000);
          }

        },
        error => {
          this.StepError(error, 4000);
          setTimeout(() => {
            this.$router.push('/login');
            this.$router.go();
          }, 5000);
        }
      );
    }
  }

</script>
<style>
  .texto {
    color: black;
  }

  .ocultar
  {
    display: none !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/RecuperaPass.vue